<template>
  <span class="TooltipMarked" @click="showTooltip()">
    <slot></slot>
  </span>
</template>

<script>
import $ from 'cash-dom'

export default {
  props: ['number'],
  data() {
    return {
      someTooltipVisible: false
    }
  },
  computed: {},
  methods: {
    showTooltip() {
      this.closeAllTooltips()
      $('.TooltipBubble[data-number="' + this.number + '"]').addClass(
        'TooltipBubble--Show'
      )
      this.someTooltipVisible = true
    },
    closeAllTooltips() {
      $('.TooltipBubble').removeClass('TooltipBubble--Show')
      this.someTooltipVisible = false
    }
  },
  mounted() {
    document.addEventListener('click', e => {
      if (e.target.classList.contains('TooltipMarked')) {
        return
      }

      const isBubble = e.target.closest('.TooltipBubble')

      if (this.someTooltipVisible && !isBubble) {
        this.closeAllTooltips()
      }
    })
  }
}
</script>

<style lang="scss" scoped></style>
